import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { CancellationPolicyAction } from "./APIs/action/index";

const CancellationPolicy = () => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    const getPolicy = async () => {
        setLoading(true);
        const data = await CancellationPolicyAction();
        setPolicy(data);
        setLoading(false);
    };
    getPolicy();
  }, []);

  if (!policy) return null;

  return (
    <Box sx={{ p: 4, display: 'flex', gap: 2, flexDirection: 'column' }}>
      <Typography variant="h1">{policy.title}</Typography>
      {(policy.description)
        ? policy.description.map((para, idx) => (
            <Typography variant="body1" key={idx}>{para}</Typography>
          ))
        : <Typography variant="body1">{policy.description}</Typography>
      }
    </Box>
  );
};

export default CancellationPolicy;